// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021juvenile/controller.php?enews=';
const projectName = '2021project/q1/2021juvenile';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const share = (context: any) => {
  context.$appShareInfo({
    title: '新时代重庆好少年评选展示',
    url: location.href,
    subtitle: '',
    classId: -1,
    id: -1,
    image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    type: 3,
  });
  // 微信分享
  if (isWeiXin()) {
    context.$wxShareInfo({
      title: '新时代重庆好少年评选展示',
      subtitle: '',
    });
  }
};
const getVoteList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
    },
  });
};
const getVoteListB = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list-audio`, {
    params: {
      page,
      search: keyword,
    },
  });
};
const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
export { getBaseInfo, share, getVoteList, getRules, getDetail, getVoteListB, projectName };
